module.exports = __webpack_public_path__ + "img/cog-wheel.4eaabd80.png";